// extracted by mini-css-extract-plugin
export var contentBody = "_7s-9";
export var headerImage = "_7s-2";
export var imageButton = "_7s-7";
export var imageButtonIcon = "_7s-8";
export var imageHeader = "_7s-4";
export var imageHeaderText = "_7s-5";
export var imageOverlay = "_7s-3";
export var imageTitle = "_7s-6";
export var imageWrapper = "_7s-1";
export var taskList = "_7s-a";
export var widget = "_7s-0";